import "es6-promise/auto";
import "./utils/polyfill/findIndex";
import "./utils/polyfill/from";
import "./utils/polyfill/find";

import Vue from "vue";

import axios from "axios";
import moment from "moment-timezone";
import "moment/locale/es";
import VueMoment from "vue-moment";
import VueAnalytics from "vue-analytics";

import store from "./store";
import index from "./router";
import App from "./App.vue";
import "./plugins/element";
import "./plugins/chart";
import "./plugins/excel";

// Layouts
import DefaultLayout from "./layouts/Default.vue";
import BlankLayout from "./layouts/Blank.vue";
import LoginLayout from "./layouts/Login.vue";
import ProcedureLayout from "./layouts/Procedure.vue";

import Vidle from "v-idle";

Vue.use(Vidle);

// I18n
import { i18n } from "./plugins/i18n";

// Configuración Moment
Vue.use(VueMoment, { moment });
Vue.filter("formatDateHour", (value) =>
  value
    ? moment(value, "x").tz("America/Santiago").format("DD/MM/YYYY HH:mm")
    : "No timestamp"
);

// Base URL API
if (
  window.location.hostname.includes("release.bhp.lifeon.cl") ||
  window.location.hostname.includes("localhost")
) {
  axios.defaults.baseURL = "https://release.bhp.lifeon.cl";
} else if (
  window.location.hostname.includes("dev.lifeon.cl") ||
  window.location.hostname.includes("dev.bhp.lifeon.cl")
) {
  axios.defaults.baseURL = "https://bhp.dev.lifeon.cl";
} else {
  axios.defaults.baseURL = "https://legacy.bhp.lifeon.cl";
}

Vue.config.productionTip = true;

// Layouts
Vue.component("default-layout", DefaultLayout);
Vue.component("blank-layout", BlankLayout);
Vue.component("login-layout", LoginLayout);
Vue.component("procedure-layout", ProcedureLayout);

// Configuración Analytics
Vue.use(VueAnalytics, {
  id: "UA-100982558-2",
  router: index,
  autoTracking: {
    exception: true,
  },
});

// Instanciar Vue con todas las configuraciones
const vm = new Vue({
  router: index,
  i18n,
  store,
  render: (h) => h(App),
}).$mount("#app");

global.vm = vm;
